module.exports = __webpack_public_path__ + "bin/6c54c105c3b7b2ef7aade076d8c02295.jpg";